// ─── TeacherPages.jsx ────────────────────────────────────────────────────────
import PasswordInput from '../components/PasswordInput';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import {
  AcademicCapIcon, CheckCircleIcon, ChevronRightIcon,
  XMarkIcon, PlusIcon, BookOpenIcon, MegaphoneIcon,
  UserCircleIcon, PencilSquareIcon,
} from '@heroicons/react/24/outline';
import { createChatPage } from './ChatPage';

export const TeacherMessages = createChatPage({ myRole: 'teacher', contactLabel: 'parents', accent: '#10c98e' });

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .ep * { box-sizing:border-box; }
  .ep { font-family:'Sora',sans-serif; color:#1a1d2e; animation:epFade .4s ease both; }
  @keyframes epFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  .ep-header { display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:1.5rem; flex-wrap:wrap; gap:1rem; }
  .ep-title  { font-size:1.35rem; font-weight:700; letter-spacing:-.02em; color:#0f1123; }
  .ep-sub    { font-size:.76rem; color:#9094a8; margin-top:3px; }

  .btn { display:inline-flex; align-items:center; gap:7px; padding:9px 16px; border:none; border-radius:10px; font-family:'Sora',sans-serif; font-size:.8rem; font-weight:600; cursor:pointer; transition:all .18s; }
  .btn svg { width:15px; height:15px; stroke-width:2; }
  .btn-blue  { background:#3b6ef8; color:white; }
  .btn-blue:hover  { background:#2d5ef0; box-shadow:0 4px 14px rgba(59,110,248,.35); transform:translateY(-1px); }
  .btn-green { background:#10c98e; color:white; }
  .btn-green:hover { background:#0db87e; }
  .btn-ghost { background:#f0f2f7; color:#6b7194; }
  .btn-ghost:hover { background:#e4e7f0; }
  .btn-red   { background:#fef2f2; color:#ef4444; border:1px solid #fecaca; }
  .btn-red:hover { background:#ef4444; color:white; }
  .btn-sm { padding:6px 12px; font-size:.74rem; }
  .btn:disabled { opacity:.5; cursor:not-allowed; transform:none !important; }

  .panel { background:white; border-radius:16px; border:1px solid #e8ebf4; overflow:hidden; margin-bottom:1rem; }
  .panel-head { display:flex; align-items:center; justify-content:space-between; padding:14px 18px; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; gap:8px; }
  .panel-title { font-size:.86rem; font-weight:600; color:#1a1d2e; }
  .row-item { display:flex; align-items:center; justify-content:space-between; padding:12px 18px; border-bottom:1px solid #f5f6fb; transition:background .12s; cursor:pointer; gap:10px; }
  .row-item:last-child { border-bottom:none; }
  .row-item:hover { background:#fafbff; }
  .row-title { font-size:.82rem; font-weight:600; color:#1a1d2e; }
  .row-sub   { font-size:.72rem; color:#9094a8; margin-top:2px; }
  .row-right svg { width:15px; height:15px; stroke:#b0b5cc; stroke-width:2; flex-shrink:0; }

  .marks-table { width:100%; border-collapse:collapse; }
  .marks-table thead { background:#fafbff; border-bottom:1px solid #edf0f9; }
  .marks-table th { padding:10px 16px; text-align:center !important; font-size:.65rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.07em; white-space:nowrap; }
  .marks-table tbody tr { border-bottom:1px solid #f3f5fb; }
  .marks-table tbody tr:last-child { border-bottom:none; }
  .marks-table td { padding:10px 16px; font-size:.8rem; vertical-align:middle; text-align:center !important; }
  .grade-input { width:70px; font-family:'Sora',sans-serif; font-size:.78rem; padding:5px 8px; border:1.5px solid #e0e4f0; border-radius:7px; background:#f8f9fc; text-align:center; outline:none; }
  .grade-input:focus { border-color:#3b6ef8; background:white; }

  .marks-cards { display:none; padding:10px; }
  .marks-card  { background:#fafbff; border-radius:10px; border:1px solid #e8ebf4; padding:11px 13px; margin-bottom:7px; display:flex; align-items:center; justify-content:space-between; gap:10px; }
  .mc-name { font-weight:600; font-size:.82rem; color:#0f1123; }
  .mc-input-wrap { display:flex; align-items:center; gap:6px; font-size:.76rem; color:#9094a8; flex-shrink:0; }

  .stat-bar { height:8px; border-radius:99px; background:#f0f2f7; overflow:hidden; margin-top:4px; }
  .stat-bar-fill { height:100%; border-radius:99px; }

  .ep-loading { display:flex; align-items:center; justify-content:center; height:200px; gap:10px; color:#9094a8; }
  .spinner { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#10c98e; border-radius:50%; animation:spin .7s linear infinite; }
  @keyframes spin { to{transform:rotate(360deg);} }
  .ep-empty { text-align:center; padding:3rem 2rem; color:#9094a8; font-size:.82rem; }

  .modal-backdrop { position:fixed; inset:0; background:rgba(15,17,35,.6); backdrop-filter:blur(4px); display:flex; align-items:center; justify-content:center; z-index:99999; padding:20px; }
  .modal { background:white; border-radius:20px; padding:26px; width:100%; max-width:520px; max-height:calc(100vh - 40px); overflow-y:auto; box-shadow:0 24px 64px rgba(0,0,0,.25); animation:modalIn .25s ease; }
  @keyframes modalIn { from{opacity:0;transform:scale(.94)} to{opacity:1;transform:scale(1)} }
  .modal-head  { display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; }
  .modal-title { font-size:1rem; font-weight:700; color:#0f1123; }
  .modal-close { width:30px; height:30px; border-radius:8px; border:none; background:#f0f2f7; color:#6b7194; cursor:pointer; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .modal-close svg { width:15px; height:15px; stroke-width:2; }
  .modal-btns { display:flex; gap:8px; justify-content:flex-end; margin-top:20px; flex-wrap:wrap; }
  .form-grid  { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
  .form-grid > *, .fg > * { min-width:0; }
  .form-field { display:flex; flex-direction:column; gap:5px; }
  .form-field.span2 { grid-column:1/-1; }
  .form-label { font-size:.68rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; }
  .form-input,.form-select,.form-textarea { font-family:'Sora',sans-serif; font-size:.82rem; padding:9px 11px; border:1.5px solid #e0e4f0; border-radius:9px; background:#f8f9fc; color:#1a1d2e; outline:none; width:100%; }
  .form-input:focus,.form-select:focus,.form-textarea:focus { border-color:#3b6ef8; background:white; }
  .form-textarea { resize:vertical; min-height:70px; }

  @media (max-width:768px) {
    .ep-title { font-size:1.1rem; }
    .marks-table-wrap { display:none !important; }
    .marks-cards { display:block; }
    .marks-header { flex-direction:column; gap:10px; }
    .marks-header-btns { display:flex; gap:8px; flex-wrap:wrap; width:100%; }
    .marks-header-btns .btn { flex:1; justify-content:center; }
    .perf-stats { grid-template-columns:repeat(2,1fr) !important; }
    .mat-item-actions { flex-direction:column; gap:6px; align-items:flex-start !important; }
    .mat-item-right { flex-direction:column; gap:6px; align-items:flex-end; }
    .modal { padding:18px; }
    .form-grid { grid-template-columns:1fr; }
    .form-field.span2 { grid-column:1; }
    .modal-btns { justify-content:stretch; }
    .modal-btns .btn { flex:1; justify-content:center; }
    .profile-card { flex-direction:column !important; align-items:flex-start !important; }
    .pw-btn { align-self:stretch !important; justify-content:center; width:100%; }
  }
`;

const fmtDate=(d)=>d?new Date(d).toLocaleDateString('en-US',{day:'numeric',month:'short',year:'numeric'}):'—';
const inits=(n='')=>n.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase()||'?';

// ─── Exams ────────────────────────────────────────────────────────────────────
export const TeacherExams = () => {
  const [exams,    setExams]    = useState([]);
  const [selected, setSelected] = useState(null);
  const [marksData,setMarksData]= useState(null);
  const [perf,     setPerf]     = useState(null);
  const [marks,    setMarks]    = useState({});
  const [view,     setView]     = useState('list');
  const [saving,   setSaving]   = useState(false);
  const [loading,  setLoading]  = useState(true);

  useEffect(()=>{api.get('/teacher/exams').then(r=>setExams(r.data)).catch(()=>toast.error('Failed')).finally(()=>setLoading(false));},[]);

  const openExam=async(exam)=>{
    setSelected(exam);setView('marks');setPerf(null);
    try{const{data}=await api.get(`/teacher/exams/${exam._id}/marks`);setMarksData(data);const m={};data.marksData.forEach(s=>{m[s.studentId]=s.marksObtained??'';});setMarks(m);}
    catch{toast.error('Failed to load marks');}
  };

  const saveMarks=async()=>{
    try{setSaving(true);const payload=marksData.marksData.map(s=>({studentId:s.studentId,marksObtained:Number(marks[s.studentId])||0}));await api.post(`/teacher/exams/${selected._id}/marks`,{marks:payload});toast.success('Marks saved');}
    catch(err){toast.error(err.response?.data?.message || 'Failed to save marks');}finally{setSaving(false);}
  };

  const loadPerf=async()=>{
    try{const{data}=await api.get(`/teacher/exams/${selected._id}/performance`);setPerf(data);setView('performance');}
    catch{toast.error('Failed');}
  };

  if (view==='marks'&&selected) return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header marks-header">
        <div>
          <div className="ep-title">{selected.title||selected.subject}</div>
          <div className="ep-sub">{selected.class?.name} · {fmtDate(selected.date)} · Total: {selected.totalMarks} marks</div>
        </div>
        <div className="marks-header-btns" style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <button className="btn btn-ghost" onClick={()=>setView('list')}>← Back</button>
          <button className="btn btn-ghost" onClick={loadPerf}>View Performance</button>
          <button className="btn btn-green" onClick={saveMarks} disabled={saving}><CheckCircleIcon />{saving?'Saving…':'Save Marks'}</button>
        </div>
      </div>
      <div className="panel">
        <div className="marks-table-wrap" style={{overflowX:'auto'}}>
          <table className="marks-table">
            <thead><tr><th>Student</th><th>Marks Obtained</th><th>Out of</th></tr></thead>
            <tbody>
              {marksData?.marksData?.map(s=>(
                <tr key={s.studentId}>
                  <td><div style={{display:'flex',alignItems:'center',gap:9}}><div style={{width:28,height:28,borderRadius:7,background:'#eef2ff',color:'#3b6ef8',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.68rem',fontWeight:700}}>{inits(s.name)}</div><span style={{fontWeight:600,fontSize:'.8rem'}}>{s.name}</span></div></td>
                  <td><input type="number" className="grade-input" value={marks[s.studentId]??''} min={0} max={selected.totalMarks} onChange={e=>setMarks({...marks,[s.studentId]:e.target.value})} /></td>
                  <td style={{color:'#9094a8',fontSize:'.78rem'}}>{selected.totalMarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="marks-cards">
          {marksData?.marksData?.map(s=>(
            <div key={s.studentId} className="marks-card">
              <div style={{display:'flex',alignItems:'center',gap:9}}>
                <div style={{width:28,height:28,borderRadius:7,background:'#eef2ff',color:'#3b6ef8',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.68rem',fontWeight:700,flexShrink:0}}>{inits(s.name)}</div>
                <div className="mc-name">{s.name}</div>
              </div>
              <div className="mc-input-wrap">
                <input type="number" className="grade-input" value={marks[s.studentId]??''} min={0} max={selected.totalMarks} onChange={e=>setMarks({...marks,[s.studentId]:e.target.value})} />
                <span>/ {selected.totalMarks}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  if (view==='performance'&&perf) return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header">
        <div><div className="ep-title">Performance — {selected?.title}</div><div className="ep-sub">Class performance analysis</div></div>
        <button className="btn btn-ghost" onClick={()=>setView('marks')}>← Back to Marks</button>
      </div>
      {perf.stats&&(
        <div className="perf-stats" style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'1rem',marginBottom:'1.2rem'}}>
          {[{label:'Average',value:`${perf.stats.average}%`},{label:'Highest',value:perf.stats.highest},{label:'Lowest',value:perf.stats.lowest},{label:'Pass Rate',value:`${perf.stats.passRate}%`},{label:'Passed',value:perf.stats.passed},{label:'Failed',value:perf.stats.failed}].map(s=>(
            <div key={s.label} style={{background:'white',borderRadius:13,border:'1px solid #e8ebf4',padding:'.9rem 1rem'}}>
              <div style={{fontSize:'.67rem',fontWeight:600,color:'#9094a8',textTransform:'uppercase',letterSpacing:'.06em'}}>{s.label}</div>
              <div style={{fontSize:'1.2rem',fontWeight:700,color:'#0f1123',fontFamily:"'JetBrains Mono',monospace",marginTop:4}}>{s.value}</div>
            </div>
          ))}
        </div>
      )}
      <div className="panel">
        <div style={{overflowX:'auto'}}>
          <table className="marks-table">
            <thead><tr><th>Student</th><th>Marks</th><th>%</th></tr></thead>
            <tbody>
              {perf.results?.map(r=>{
                const pct=perf.exam?.totalMarks?((r.marksObtained/perf.exam.totalMarks)*100).toFixed(1):0;
                return(
                  <tr key={r._id}>
                    <td>{r.student?.user?.name}</td>
                    <td style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600}}>{r.marksObtained} / {perf.exam?.totalMarks}</td>
                    <td><div style={{fontSize:'.74rem',fontWeight:600,color:pct>=40?'#10c98e':'#ef4444'}}>{pct}%</div><div className="stat-bar"><div className="stat-bar-fill" style={{width:`${pct}%`,background:pct>=40?'#10c98e':'#ef4444'}}/></div></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header"><div><div className="ep-title">Exams & Marks</div><div className="ep-sub">Enter and manage student marks</div></div></div>
      <div className="panel">
        <div className="panel-head"><div className="panel-title">Your Exams ({exams.length})</div></div>
        {loading?<div className="ep-loading"><div className="spinner"/>Loading…</div>
        :exams.length===0?<div className="ep-empty">No exams found for your classes.</div>
        :exams.map(e=>(
          <div key={e._id} className="row-item" onClick={()=>openExam(e)}>
            <div style={{flex:1,minWidth:0}}><div className="row-title">{e.title||e.subject}</div><div className="row-sub">{e.class?.name} · {e.subject} · {fmtDate(e.date)} · {e.totalMarks} marks</div></div>
            <div className="row-right"><ChevronRightIcon /></div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Materials ────────────────────────────────────────────────────────────────
export const TeacherMaterials = () => {
  const SUBJ_COLORS = ['#3b6ef8','#10c98e','#f59e0b','#8b5cf6','#ef4444','#06b6d4','#84cc16','#f97316'];
  const TYPE_COLORS = { pdf:'#ef4444', doc:'#3b6ef8', ppt:'#f59e0b', image:'#10c98e', video:'#8b5cf6', youtube:'#ef4444', other:'#6b7194' };
  const TYPE_LABELS = { pdf:'PDF', doc:'DOC', ppt:'PPT', image:'IMG', video:'VID', youtube:'YT', other:'FILE' };
  const formatSize  = (b) => b ? (b > 1024*1024 ? `${(b/1024/1024).toFixed(1)} MB` : `${(b/1024).toFixed(0)} KB`) : null;

  const [navStep,       setNavStep]       = useState('grades');
  const [activeClass,   setActiveClass]   = useState(null);
  const [activeSection, setActiveSection] = useState('');
  const [activeSubject, setActiveSubject] = useState('');
  const [classes,         setClasses]         = useState([]);
  const [teacherSubjects, setTeacherSubjects] = useState([]);
  const [materials,       setMaterials]       = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [open,         setOpen]         = useState(false);
  const [saving,       setSaving]       = useState(false);
  const [uploadMode,   setUploadMode]   = useState('file');
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragOver,     setDragOver]     = useState(false);
  const [uploadPct,    setUploadPct]    = useState(0);
  const [showPreview,  setShowPreview]  = useState(false); // ← NEW
  const [form, setForm] = useState({ title:'', description:'', youtubeUrl:'' });

  useEffect(() => {
    Promise.all([api.get('/teacher/classes'), api.get('/teacher/profile')])
      .then(([c, p]) => {
        setClasses(c.data.classes || []);
        setTeacherSubjects(p.data.subjects || []);
      }).catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  const fetchMaterials = async (classId, section, subject) => {
    try {
      setLoading(true);
      const { data } = await api.get('/teacher/materials', { params: { classId, section, subject } });
      setMaterials(data);
    } catch { toast.error('Failed to load materials'); }
    finally { setLoading(false); }
  };

  const goGrades   = () => { setNavStep('grades'); setActiveClass(null); setActiveSection(''); setActiveSubject(''); };
  const goSections = (cls) => { setActiveClass(cls); setActiveSection(''); setNavStep('sections'); };
  const goSubjects = (sec) => { setActiveSection(sec); setNavStep('subjects'); };
  const goList     = (subj) => { setActiveSubject(subj); setNavStep('list'); fetchMaterials(activeClass._id, activeSection, subj); };

  const resetModal = () => {
    setForm({ title:'', description:'', youtubeUrl:'' });
    setSelectedFile(null);
    setUploadPct(0);
    setUploadMode('file');
    setShowPreview(false);
  };

  const handleFileSelect = (file) => {
    if (!file) return;
    setSelectedFile(file);
    if (!form.title) setForm(f => ({ ...f, title: file.name.replace(/\.[^/.]+$/, '').replace(/[-_]/g, ' ').trim() }));
  };

  // Validate then show preview
  const handlePreviewRequest = () => {
    if (!form.title.trim()) { toast.error('Title is required'); return; }
    if (uploadMode === 'file' && !selectedFile) { toast.error('Please select a file'); return; }
    if (uploadMode === 'youtube' && !form.youtubeUrl.trim()) { toast.error('Please enter a YouTube URL'); return; }
    setShowPreview(true);
  };

  const handleCreate = async () => {
    if (!form.title) { toast.error('Title is required'); return; }
    if (uploadMode === 'file' && !selectedFile) { toast.error('Please select a file'); return; }
    if (uploadMode === 'youtube' && !form.youtubeUrl) { toast.error('Please enter a YouTube URL'); return; }
    try {
      setSaving(true);
      const fd = new FormData();
      fd.append('title', form.title); fd.append('description', form.description);
      fd.append('subject', activeSubject); fd.append('classId', activeClass?._id || '');
      fd.append('section', activeSection || '');
      if (uploadMode === 'file') fd.append('file', selectedFile);
      else fd.append('youtubeUrl', form.youtubeUrl);
      const { data } = await api.post('/teacher/materials', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => setUploadPct(Math.round((e.loaded*100)/e.total)),
      });
      setMaterials([data, ...materials]);
      toast.success('Material uploaded — pending admin approval');
      setOpen(false);
      resetModal();
    } catch (err) { toast.error(err.response?.data?.message || 'Upload failed'); }
    finally { setSaving(false); setUploadPct(0); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this material?')) return;
    try { await api.delete(`/teacher/materials/${id}`); setMaterials(materials.filter(m => m._id !== id)); toast.success('Deleted'); }
    catch { toast.error('Failed to delete'); }
  };

  const Breadcrumb = () => (
    <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:'1.2rem',flexWrap:'wrap'}}>
      <span style={{fontSize:'.78rem',fontWeight:600,color:'#9094a8',cursor:'pointer'}} onClick={goGrades}>Materials</span>
      {activeClass && <><span style={{color:'#d1d5db'}}>›</span>
        <span style={{fontSize:'.78rem',fontWeight:600,color:navStep==='sections'?'#0f1123':'#9094a8',cursor:'pointer'}}
          onClick={() => { setNavStep('sections'); setActiveSection(''); setActiveSubject(''); }}>{activeClass.name}</span></>}
      {activeSection && <><span style={{color:'#d1d5db'}}>›</span>
        <span style={{fontSize:'.78rem',fontWeight:600,color:navStep==='subjects'?'#0f1123':'#9094a8',cursor:'pointer'}}
          onClick={() => { setNavStep('subjects'); setActiveSubject(''); }}>Section {activeSection}</span></>}
      {activeSubject && <><span style={{color:'#d1d5db'}}>›</span>
        <span style={{fontSize:'.78rem',fontWeight:600,color:'#0f1123'}}>{activeSubject}</span></>}
    </div>
  );

  // ── LIST ────────────────────────────────────────────────────────────────────
  if (navStep === 'list') return (
    <div className="ep"><style>{style}</style>
      <Breadcrumb />
      <div className="ep-header">
        <div><div className="ep-title">{activeSubject}</div><div className="ep-sub">{activeClass?.name} · Section {activeSection}</div></div>
        <button className="btn btn-blue" onClick={() => { resetModal(); setOpen(true); }}><PlusIcon />Upload Material</button>
      </div>
      <div className="panel">
        <div className="panel-head"><div className="panel-title">Materials ({materials.length})</div></div>
        {loading ? <div className="ep-loading"><div className="spinner"/>Loading…</div>
        : materials.length === 0 ? (
          <div className="ep-empty">No materials for {activeSubject} yet.
            <div style={{marginTop:12}}><button className="btn btn-blue btn-sm" onClick={() => { resetModal(); setOpen(true); }}><PlusIcon />Upload First</button></div>
          </div>
        ) : materials.map(m => (
          <div key={m._id} style={{padding:'13px 18px',borderBottom:'1px solid #f5f6fb',display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12,flexWrap:'wrap'}}>
            <div style={{display:'flex',alignItems:'flex-start',gap:12,flex:1,minWidth:0}}>
              <div style={{width:36,height:36,borderRadius:9,background:`${TYPE_COLORS[m.type]||'#6b7194'}18`,color:TYPE_COLORS[m.type]||'#6b7194',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.65rem',fontWeight:700,flexShrink:0}}>{TYPE_LABELS[m.type]||'FILE'}</div>
              <div style={{minWidth:0}}>
                <div style={{display:'flex',alignItems:'center',gap:7,flexWrap:'wrap'}}>
                  <span style={{fontWeight:600,fontSize:'.82rem',color:'#0f1123'}}>{m.title}</span>
                  {m.approved ? <span style={{fontSize:'.62rem',fontWeight:600,padding:'2px 7px',borderRadius:99,background:'#ecfdf5',color:'#10c98e'}}>✓ Approved</span>
                  : m.rejectionReason ? <span style={{fontSize:'.62rem',fontWeight:600,padding:'2px 7px',borderRadius:99,background:'#fef2f2',color:'#ef4444'}}>✕ Rejected</span>
                  : <span style={{fontSize:'.62rem',fontWeight:600,padding:'2px 7px',borderRadius:99,background:'#fffbeb',color:'#f59e0b'}}>Pending</span>}
                </div>
                <div style={{fontSize:'.7rem',color:'#9094a8',marginTop:2}}>{m.fileSize && `${formatSize(m.fileSize)} · `}{fmtDate(m.createdAt)}</div>
                {m.description && <div style={{fontSize:'.72rem',color:'#6b7194',marginTop:2}}>{m.description}</div>}
                {m.rejectionReason && <div style={{fontSize:'.68rem',color:'#ef4444',marginTop:2}}>Reason: {m.rejectionReason}</div>}
              </div>
            </div>
            <div style={{display:'flex',gap:6,alignItems:'center',flexShrink:0}}>
              {(m.fileUrl||m.youtubeUrl) && <a href={m.fileUrl||m.youtubeUrl} target="_blank" rel="noreferrer" className="btn btn-ghost btn-sm">{m.type==='youtube'?'Watch':m.type==='video'?'Play':m.type==='image'?'View':'Open'}</a>}
              <button className="btn btn-red btn-sm" onClick={() => handleDelete(m._id)}><XMarkIcon /></button>
            </div>
          </div>
        ))}
      </div>

      {/* ── Upload Modal ── */}
      {open && ReactDOM.createPortal(
        <div className="modal-backdrop" onClick={() => { if (!saving) { setOpen(false); resetModal(); } }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <div className="modal-title">Upload — {activeSubject}</div>
              <button className="modal-close" onClick={() => { setOpen(false); resetModal(); }} disabled={saving}><XMarkIcon /></button>
            </div>
            <div style={{display:'flex',gap:6,marginBottom:16,background:'#f0f2f7',borderRadius:10,padding:4}}>
              {['file','youtube'].map(mode => (
                <button key={mode} onClick={() => setUploadMode(mode)}
                  style={{flex:1,padding:'7px 0',borderRadius:7,border:'none',fontFamily:"'Sora',sans-serif",fontSize:'.78rem',fontWeight:600,cursor:'pointer',background:uploadMode===mode?'white':'transparent',color:uploadMode===mode?'#1a1d2e':'#9094a8',boxShadow:uploadMode===mode?'0 1px 4px rgba(0,0,0,.1)':'none'}}>
                  {mode==='file'?'📁 Upload File':'🎬 YouTube Link'}
                </button>
              ))}
            </div>
            <div className="form-grid">
              <div className="form-field span2">
                <label className="form-label">Title *</label>
                <input type="text" className="form-input" value={form.title} onChange={e => setForm({...form, title:e.target.value})} placeholder="e.g. Chapter 5 Notes" />
              </div>
              {uploadMode === 'file' ? (
                <div className="form-field span2">
                  <label className="form-label">File *</label>
                  <div onDragOver={e=>{e.preventDefault();setDragOver(true);}} onDragLeave={()=>setDragOver(false)}
                    onDrop={e=>{e.preventDefault();setDragOver(false);handleFileSelect(e.dataTransfer.files[0]);}}
                    onClick={() => document.getElementById('tm-file-input').click()}
                    style={{border:`2px dashed ${dragOver?'#3b6ef8':'#d0d5e8'}`,borderRadius:10,padding:'20px',textAlign:'center',cursor:'pointer',background:dragOver?'#f0f4ff':'#fafbfc'}}>
                    <input id="tm-file-input" type="file" accept="image/*,video/*,.pdf,.doc,.docx,.ppt,.pptx,.zip,.xls,.xlsx,.txt" style={{display:'none'}} onChange={e => handleFileSelect(e.target.files[0])} />
                    {selectedFile ? (
                      <div>
                        <div style={{fontSize:'1.5rem',marginBottom:6}}>{selectedFile.type.startsWith('image/')?'🖼️':selectedFile.type.startsWith('video/')?'🎬':'📄'}</div>
                        <div style={{fontWeight:600,fontSize:'.82rem'}}>{selectedFile.name}</div>
                        <div style={{fontSize:'.72rem',color:'#9094a8',marginTop:3}}>{formatSize(selectedFile.size)}</div>
                      </div>
                    ) : (
                      <div>
                        <div style={{fontSize:'2rem',marginBottom:8}}>☁️</div>
                        <div style={{fontWeight:600,fontSize:'.82rem',color:'#1a1d2e'}}>Tap to select file</div>
                        <div style={{fontSize:'.72rem',color:'#9094a8',marginTop:4}}>Images, Videos, PDF, DOCX, PPTX</div>
                      </div>
                    )}
                  </div>
                  {saving && uploadPct > 0 && (
                    <div style={{marginTop:8}}>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:'.72rem',color:'#6b7194',marginBottom:4}}><span>Uploading…</span><span>{uploadPct}%</span></div>
                      <div style={{height:6,background:'#f0f2f7',borderRadius:99,overflow:'hidden'}}><div style={{height:'100%',background:'#3b6ef8',borderRadius:99,width:`${uploadPct}%`,transition:'width .3s'}}/></div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="form-field span2">
                  <label className="form-label">YouTube URL *</label>
                  <input type="url" className="form-input" value={form.youtubeUrl} onChange={e => setForm({...form, youtubeUrl:e.target.value})} placeholder="https://www.youtube.com/watch?v=…" />
                </div>
              )}
              <div className="form-field span2">
                <label className="form-label">Description (optional)</label>
                <textarea className="form-textarea" value={form.description} onChange={e => setForm({...form, description:e.target.value})} placeholder="Brief description…" />
              </div>
            </div>
            <div className="modal-btns">
              <button className="btn btn-ghost" onClick={() => { setOpen(false); resetModal(); }} disabled={saving}>Cancel</button>
              {/* Shows preview instead of direct upload */}
              <button className="btn btn-blue" onClick={handlePreviewRequest} disabled={saving}>
                Preview Before Uploading
              </button>
            </div>
          </div>
        </div>
      , document.body)}

      {/* ── Preview Confirm Modal ── */}
      {showPreview && ReactDOM.createPortal(
        <div className="modal-backdrop" style={{zIndex:100000}} onClick={() => setShowPreview(false)}>
          <div className="modal" style={{maxWidth:480}} onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <div className="modal-title">Preview Before Uploading</div>
              <button className="modal-close" onClick={() => setShowPreview(false)}><XMarkIcon /></button>
            </div>

            <div style={{background:'#f8f9fc',borderRadius:12,border:'1px solid #e8ebf4',padding:'14px 16px',marginBottom:14}}>
              {/* File preview */}
              {uploadMode === 'file' && selectedFile && (
                <div style={{marginBottom:12,paddingBottom:12,borderBottom:'1px solid #edf0f9'}}>
                  <div style={{display:'flex',alignItems:'center',gap:12}}>
                    <div style={{width:44,height:44,borderRadius:10,background:'#eef2ff',color:'#3b6ef8',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.4rem',flexShrink:0}}>
                      {selectedFile.type.startsWith('image/') ? '🖼️' : selectedFile.type.startsWith('video/') ? '🎬' : selectedFile.type.includes('pdf') ? '📄' : selectedFile.type.includes('ppt') ? '📊' : selectedFile.type.includes('doc') ? '📝' : '📁'}
                    </div>
                    <div>
                      <div style={{fontWeight:700,fontSize:'.84rem',color:'#0f1123'}}>{selectedFile.name}</div>
                      <div style={{fontSize:'.72rem',color:'#9094a8',marginTop:2}}>{formatSize(selectedFile.size)}</div>
                    </div>
                  </div>
                  {/* Image thumbnail */}
                  {selectedFile.type.startsWith('image/') && (
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="preview"
                      style={{maxHeight:140,maxWidth:'100%',marginTop:10,borderRadius:8,border:'1px solid #e8ebf4',display:'block'}}
                    />
                  )}
                </div>
              )}

              {/* YouTube preview */}
              {uploadMode === 'youtube' && (
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12,paddingBottom:12,borderBottom:'1px solid #edf0f9'}}>
                  <span style={{fontSize:'1.6rem'}}>🎬</span>
                  <div style={{fontSize:'.78rem',color:'#0f1123',fontWeight:600,wordBreak:'break-all'}}>{form.youtubeUrl}</div>
                </div>
              )}

              {/* Detail rows */}
              {[
                { label: 'Title',       value: form.title },
                { label: 'Subject',     value: activeSubject },
                { label: 'Class',       value: activeClass?.name },
                { label: 'Section',     value: activeSection ? `Section ${activeSection}` : null },
                { label: 'Description', value: form.description || null },
              ].filter(r => r.value).map(r => (
                <div key={r.label} style={{display:'flex',gap:12,padding:'6px 0',borderBottom:'1px solid #f3f5fb',fontSize:'.8rem',alignItems:'flex-start'}}>
                  <span style={{color:'#9094a8',fontWeight:600,minWidth:80,flexShrink:0,fontSize:'.7rem',textTransform:'uppercase',letterSpacing:'.04em',paddingTop:2}}>{r.label}</span>
                  <span style={{color:'#0f1123',fontWeight:500}}>{r.value}</span>
                </div>
              ))}
            </div>

            <div style={{fontSize:'.76rem',color:'#92400e',marginBottom:16,background:'#fffbeb',border:'1px solid #fde68a',borderRadius:9,padding:'9px 12px',display:'flex',gap:8,alignItems:'flex-start'}}>
              <span style={{flexShrink:0}}>⚠️</span>
              <span>After uploading, this material will be sent for <strong>admin approval</strong> before students can see it.</span>
            </div>

            <div className="modal-btns">
              <button className="btn btn-ghost" onClick={() => setShowPreview(false)}>← Go Back & Edit</button>
              <button className="btn btn-blue" onClick={() => { setShowPreview(false); handleCreate(); }} disabled={saving}>
                {saving ? `Uploading ${uploadPct > 0 ? uploadPct + '%' : '…'}` : '✓ Confirm & Upload'}
              </button>
            </div>
          </div>
        </div>
      , document.body)}
    </div>
  );

  // ── SUBJECTS ────────────────────────────────────────────────────────────────
  if (navStep === 'subjects') return (
    <div className="ep"><style>{style}</style>
      <Breadcrumb />
      <div className="ep-header"><div><div className="ep-title">Section {activeSection}</div><div className="ep-sub">{activeClass?.name} · Select a subject</div></div></div>
      {teacherSubjects.length === 0 ? <div className="ep-empty">No subjects found.</div> : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(190px,1fr))',gap:'1rem'}}>
          {teacherSubjects.map((subj, i) => (
            <div key={subj} onClick={() => goList(subj)}
              style={{background:'white',borderRadius:14,border:'1px solid #e8ebf4',padding:'1.1rem 1.2rem',cursor:'pointer',transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='#3b6ef8';e.currentTarget.style.transform='translateY(-1px)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8ebf4';e.currentTarget.style.transform='none';}}>
              <div style={{width:32,height:32,borderRadius:9,background:`${SUBJ_COLORS[i%SUBJ_COLORS.length]}18`,color:SUBJ_COLORS[i%SUBJ_COLORS.length],display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'.72rem',marginBottom:8}}>{subj.slice(0,2).toUpperCase()}</div>
              <div style={{fontSize:'.95rem',fontWeight:700,color:'#0f1123',marginBottom:3}}>{subj}</div>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10}}>
                <span style={{fontSize:'.72rem',color:SUBJ_COLORS[i%SUBJ_COLORS.length],fontWeight:600}}>View materials</span>
                <ChevronRightIcon style={{width:15,height:15,stroke:SUBJ_COLORS[i%SUBJ_COLORS.length]}} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  // ── SECTIONS ────────────────────────────────────────────────────────────────
  if (navStep === 'sections') return (
    <div className="ep"><style>{style}</style>
      <Breadcrumb />
      <div className="ep-header"><div><div className="ep-title">{activeClass?.name}</div><div className="ep-sub">Select a section</div></div></div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(190px,1fr))',gap:'1rem'}}>
        {(activeClass?.sections || []).map((sec, i) => (
          <div key={sec} onClick={() => goSubjects(sec)}
            style={{background:'white',borderRadius:14,border:'1px solid #e8ebf4',padding:'1.1rem 1.2rem',cursor:'pointer',transition:'all .15s'}}
            onMouseEnter={e=>{e.currentTarget.style.borderColor='#3b6ef8';e.currentTarget.style.transform='translateY(-1px)';}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8ebf4';e.currentTarget.style.transform='none';}}>
            <div style={{width:36,height:36,borderRadius:10,background:`${SUBJ_COLORS[i%SUBJ_COLORS.length]}18`,color:SUBJ_COLORS[i%SUBJ_COLORS.length],display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'.9rem',marginBottom:8}}>{sec}</div>
            <div style={{fontSize:'.95rem',fontWeight:700,color:'#0f1123',marginBottom:3}}>Section {sec}</div>
            <div style={{fontSize:'.72rem',color:'#9094a8'}}>{teacherSubjects.length} subject{teacherSubjects.length!==1?'s':''}</div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10}}>
              <span style={{fontSize:'.72rem',color:SUBJ_COLORS[i%SUBJ_COLORS.length],fontWeight:600}}>View subjects</span>
              <ChevronRightIcon style={{width:15,height:15,stroke:SUBJ_COLORS[i%SUBJ_COLORS.length]}} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // ── GRADE CARDS ─────────────────────────────────────────────────────────────
  return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header"><div><div className="ep-title">Teaching Materials</div><div className="ep-sub">Select a class to manage materials</div></div></div>
      {loading ? <div className="ep-loading"><div className="spinner"/>Loading…</div>
      : classes.length === 0 ? <div className="ep-empty">No classes assigned yet.</div>
      : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:'1rem'}}>
          {classes.map((cls, i) => (
            <div key={cls._id} onClick={() => goSections(cls)}
              style={{background:'white',borderRadius:14,border:'1px solid #e8ebf4',padding:'1.1rem 1.2rem',cursor:'pointer',transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='#3b6ef8';e.currentTarget.style.transform='translateY(-1px)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8ebf4';e.currentTarget.style.transform='none';}}>
              <div style={{width:36,height:36,borderRadius:10,background:`${SUBJ_COLORS[i%SUBJ_COLORS.length]}18`,color:SUBJ_COLORS[i%SUBJ_COLORS.length],display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'.8rem',marginBottom:8}}>{cls.name?.replace('Grade ','G').slice(0,3)}</div>
              <div style={{fontSize:'.95rem',fontWeight:700,color:'#0f1123',marginBottom:3}}>{cls.name}</div>
              <div style={{fontSize:'.72rem',color:'#9094a8'}}>{cls.sections?.length||0} section{cls.sections?.length!==1?'s':''}</div>
              {teacherSubjects.length > 0 && (
                <div style={{display:'flex',gap:4,flexWrap:'wrap',marginTop:6}}>
                  {teacherSubjects.map(s => <span key={s} style={{fontSize:'.65rem',fontWeight:600,padding:'2px 7px',borderRadius:99,background:'#f3f0ff',color:'#8b5cf6'}}>{s}</span>)}
                </div>
              )}
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10}}>
                <span style={{fontSize:'.72rem',color:'#3b6ef8',fontWeight:600}}>View sections</span>
                <ChevronRightIcon style={{width:15,height:15,stroke:'#3b6ef8'}} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ─── Notices ──────────────────────────────────────────────────────────────────
export const TeacherNotices = () => {
  const [notices,setNotices]=useState([]);
  const [classes,setClasses]=useState([]);
  const [loading,setLoading]=useState(true);
  const [open,   setOpen]   =useState(false);
  const [saving, setSaving] =useState(false);
  const [form,setForm]=useState({title:'',content:'',classId:'',section:''});
  const [mode,setMode]=useState('broadcast'); // 'broadcast' | 'specific'
  const [targetRole,setTargetRole]=useState('student'); // 'student' | 'parent'
  const [students,setStudents]=useState([]);
  const [selectedStudents,setSelectedStudents]=useState([]);
  const [parents,setParents]=useState([]);
  const [selectedParents,setSelectedParents]=useState([]);

  useEffect(()=>{
    Promise.all([api.get('/teacher/notices'),api.get('/teacher/classes')])
      .then(([n,c])=>{setNotices(n.data);setClasses(c.data.classes||[]);})
      .catch(()=>toast.error('Failed')).finally(()=>setLoading(false));
  },[]);

  useEffect(()=>{
    setSelectedStudents([]); setSelectedParents([]);
    if(mode!=='specific'||!form.classId){setStudents([]);setParents([]);return;}
    const sectionParam=form.section?`?section=${form.section}`:'';
    if(targetRole==='parent'){
      api.get(`/teacher/classes/${form.classId}/parents${sectionParam}`)
        .then(r=>setParents(r.data||[])).catch(()=>setParents([]));
    } else {
      api.get(`/teacher/classes/${form.classId}/students${sectionParam}`)
        .then(r=>setStudents(r.data||[])).catch(()=>setStudents([]));
    }
  },[mode,form.classId,form.section,targetRole]);

  const toggleStudent=(userId)=>{
    setSelectedStudents(prev=>prev.includes(userId)?prev.filter(id=>id!==userId):[...prev,userId]);
  };
  const toggleParent=(userId)=>{
    setSelectedParents(prev=>prev.includes(userId)?prev.filter(id=>id!==userId):[...prev,userId]);
  };

  const resetForm=()=>{
    setForm({title:'',content:'',classId:'',section:''});
    setMode('broadcast'); setTargetRole('student');
    setSelectedStudents([]); setStudents([]); setSelectedParents([]); setParents([]);
  };

  const switchMode=(m)=>{
    setMode(m);
    // "Specific student(s)" needs one real class selected — "All Classes" doesn't apply there.
    if(m==='specific'&&form.classId==='__all__') setForm(f=>({...f,classId:'',section:''}));
  };

  const switchRole=(r)=>{
    setTargetRole(r); setSelectedStudents([]); setSelectedParents([]);
  };

  const handlePost=async()=>{
    if(!form.title||!form.content){toast.error('Title and content required');return;}
    if(!form.classId){toast.error('Select a class');return;}
    if(mode==='specific'&&targetRole==='student'&&selectedStudents.length===0){toast.error('Select at least one student');return;}
    if(mode==='specific'&&targetRole==='parent'&&selectedParents.length===0){toast.error('Select at least one parent');return;}
    try{
      setSaving(true);
      const payload=mode==='specific'
        ? {title:form.title,content:form.content,audience:[targetRole],targetRole,targetUsers:targetRole==='parent'?selectedParents:selectedStudents}
        : form.classId==='__all__'
          ? {title:form.title,content:form.content,audience:[targetRole],targetRole,allClasses:true}
          : {title:form.title,content:form.content,audience:[targetRole],targetRole,classId:form.classId,section:form.section||undefined};
      const{data}=await api.post('/teacher/notices',payload);
      setNotices([data,...notices]);toast.success('Notice posted');setOpen(false);resetForm();
    }
    catch(err){toast.error(err.response?.data?.message||'Failed');}finally{setSaving(false);}
  };

  const handleDelete=async(id)=>{
    try{await api.delete(`/teacher/notices/${id}`);setNotices(notices.filter(n=>n._id!==id));toast.success('Deleted');}
    catch(err){toast.error(err.response?.data?.message||'Failed');}
  };

  return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header">
        <div><div className="ep-title">Notices</div><div className="ep-sub">View admin notices and post to your students</div></div>
        <button className="btn btn-blue" onClick={()=>setOpen(true)}><PlusIcon />Post Notice</button>
      </div>
      <div className="panel">
        <div className="panel-head"><div className="panel-title">All Notices ({notices.length})</div></div>
        {loading?<div className="ep-loading"><div className="spinner"/>Loading…</div>
        :notices.length===0?<div className="ep-empty">No notices yet.</div>
        :notices.map(n=>(
          <div key={n._id} style={{padding:'14px 18px',borderBottom:'1px solid #f5f6fb'}}>
            <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:10,flexWrap:'wrap'}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:'.84rem',color:'#0f1123',marginBottom:4}}>{n.title}</div>
                <div style={{fontSize:'.78rem',color:'#6b7194',lineHeight:1.5}}>{n.content}</div>
                <div style={{fontSize:'.68rem',color:'#b0b5cc',marginTop:6}}>{n.postedBy?.name} · {fmtDate(n.createdAt)} · {Array.isArray(n.audience)?n.audience.join(', '):n.audience}</div>
              </div>
              {n.postedBy?._id&&<button className="btn btn-red btn-sm" onClick={()=>handleDelete(n._id)} style={{flexShrink:0}}><XMarkIcon /></button>}
            </div>
          </div>
        ))}
      </div>

      {open&&ReactDOM.createPortal(
        <div className="modal-backdrop" onClick={()=>setOpen(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-head"><div className="modal-title">Post Notice</div><button className="modal-close" onClick={()=>setOpen(false)}><XMarkIcon /></button></div>
            <div className="form-grid">
              <div className="form-field span2"><label className="form-label">Title</label><input type="text" className="form-input" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Notice title…" /></div>
              <div className="form-field span2"><label className="form-label">Content</label><textarea className="form-textarea" value={form.content} onChange={e=>setForm({...form,content:e.target.value})} placeholder="Write your notice…" style={{minHeight:100}} /></div>
              <div className="form-field span2"><label className="form-label">Notify</label>
                <div style={{display:'flex',gap:6}}>
                  <button type="button" className={`btn ${targetRole==='student'?'btn-blue':'btn-ghost'} btn-sm`} style={{flex:1,justifyContent:'center'}} onClick={()=>switchRole('student')}>Students</button>
                  <button type="button" className={`btn ${targetRole==='parent'?'btn-blue':'btn-ghost'} btn-sm`} style={{flex:1,justifyContent:'center'}} onClick={()=>switchRole('parent')}>Parents</button>
                </div>
              </div>
              <div className="form-field span2"><label className="form-label">Send To</label>
                <div style={{display:'flex',gap:6}}>
                  <button type="button" className={`btn ${mode==='broadcast'?'btn-blue':'btn-ghost'} btn-sm`} style={{flex:1,justifyContent:'center'}} onClick={()=>switchMode('broadcast')}>All in class/section</button>
                  <button type="button" className={`btn ${mode==='specific'?'btn-blue':'btn-ghost'} btn-sm`} style={{flex:1,justifyContent:'center'}} onClick={()=>switchMode('specific')}>Specific {targetRole==='parent'?'parent(s)':'student(s)'}</button>
                </div>
              </div>
              <div className="form-field"><label className="form-label">Class</label>
                <select className="form-select" value={form.classId} onChange={e=>setForm({...form,classId:e.target.value,section:''})}>
                  <option value="">Select class…</option>
                  {mode==='broadcast'&&<option value="__all__">All Classes</option>}
                  {classes.map(c=><option key={c._id} value={c._id}>{c.name}</option>)}
                </select>
              </div>
              <div className="form-field"><label className="form-label">Section</label>
                <select className="form-select" value={form.section} onChange={e=>setForm({...form,section:e.target.value})} disabled={!form.classId||form.classId==='__all__'}>
                  <option value="">All sections</option>
                  {(classes.find(c=>String(c._id)===String(form.classId))?.sections||[]).map(s=><option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              {mode==='specific'&&targetRole==='student'&&(
                <div className="form-field span2"><label className="form-label">Students {selectedStudents.length>0?`(${selectedStudents.length} selected)`:''}</label>
                  {!form.classId ? <div style={{fontSize:'.78rem',color:'#9094a8'}}>Select a class first</div>
                  : students.length===0 ? <div style={{fontSize:'.78rem',color:'#9094a8'}}>No students found</div>
                  : (
                    <div style={{maxHeight:180,overflowY:'auto',border:'1.5px solid #e0e4f0',borderRadius:10,padding:8}}>
                      {students.map(s=>(
                        <label key={s.user._id} style={{display:'flex',alignItems:'center',gap:8,padding:'5px 4px',fontSize:'.8rem',cursor:'pointer'}}>
                          <input type="checkbox" checked={selectedStudents.includes(String(s.user._id))} onChange={()=>toggleStudent(String(s.user._id))} />
                          {s.user?.name} <span style={{color:'#9094a8'}}>({s.rollNo||s.admissionNo})</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {mode==='specific'&&targetRole==='parent'&&(
                <div className="form-field span2"><label className="form-label">Parents {selectedParents.length>0?`(${selectedParents.length} selected)`:''}</label>
                  {!form.classId ? <div style={{fontSize:'.78rem',color:'#9094a8'}}>Select a class first</div>
                  : parents.length===0 ? <div style={{fontSize:'.78rem',color:'#9094a8'}}>No parents found</div>
                  : (
                    <div style={{maxHeight:180,overflowY:'auto',border:'1.5px solid #e0e4f0',borderRadius:10,padding:8}}>
                      {parents.map(p=>(
                        <label key={p.userId} style={{display:'flex',alignItems:'center',gap:8,padding:'5px 4px',fontSize:'.8rem',cursor:'pointer'}}>
                          <input type="checkbox" checked={selectedParents.includes(String(p.userId))} onChange={()=>toggleParent(String(p.userId))} />
                          {p.name} <span style={{color:'#9094a8'}}>(parent of {p.childName})</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="modal-btns">
              <button className="btn btn-ghost" onClick={()=>setOpen(false)}>Cancel</button>
              <button className="btn btn-blue" onClick={handlePost} disabled={saving}>{saving?'Posting…':'Post Notice'}</button>
            </div>
          </div>
        </div>
      ,document.body)}
    </div>
  );
};

// ─── Profile ──────────────────────────────────────────────────────────────────
export const TeacherProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pwSaving,setPwSaving]= useState(false);
  const [pwForm,  setPwForm]  = useState({currentPassword:'',newPassword:'',confirm:''});

  useEffect(()=>{api.get('/teacher/profile').then(r=>{setProfile(r.data);}).catch(()=>toast.error('Failed')).finally(()=>setLoading(false));},[]);

  const handleChangePassword=async()=>{
    if(!pwForm.currentPassword||!pwForm.newPassword){toast.error('All fields required');return;}
    if(pwForm.newPassword!==pwForm.confirm){toast.error('Passwords do not match');return;}
    try{setPwSaving(true);await api.put('/teacher/profile/password',{currentPassword:pwForm.currentPassword,newPassword:pwForm.newPassword});toast.success('Password changed');setPwForm({currentPassword:'',newPassword:'',confirm:''});}
    catch(err){toast.error(err.response?.data?.message||'Failed');}finally{setPwSaving(false);}
  };

  if(loading)return<div className="ep"><style>{style}</style><div className="ep-loading"><div className="spinner"/>Loading…</div></div>;
  const ini=(n='')=>n.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase()||'?';

  return (
    <div className="ep"><style>{style}</style>
      <div className="ep-header"><div><div className="ep-title">My Profile</div><div className="ep-sub">Manage your account details</div></div></div>

      <div className="profile-card" style={{background:'white',borderRadius:16,border:'1px solid #e8ebf4',padding:'1.4rem 1.6rem',marginBottom:'1rem',display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
        <div style={{width:60,height:60,borderRadius:16,background:'linear-gradient(135deg,#10c98e,#3b6ef8)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.2rem',fontWeight:700,color:'white',flexShrink:0}}>{ini(profile?.name)}</div>
        <div>
          <div style={{fontSize:'1.1rem',fontWeight:700,color:'#0f1123'}}>{profile?.name}</div>
          <div style={{fontSize:'.76rem',color:'#9094a8',marginTop:2}}>{profile?.email}</div>
          <div style={{fontSize:'.72rem',color:'#b0b5cc',marginTop:2}}>Employee ID: {profile?.employeeId} · {profile?.subjects?.join(', ')}</div>
        </div>
      </div>

      <div className="panel">
        <div className="panel-head"><div className="panel-title">Change Password</div></div>
        <div style={{padding:'16px 18px',display:'flex',flexDirection:'column',gap:12,maxWidth:400}}>
          {[{label:'Current Password',key:'currentPassword'},{label:'New Password',key:'newPassword'},{label:'Confirm New Password',key:'confirm'}].map(f=>(
            <div key={f.key} style={{display:'flex',flexDirection:'column',gap:5}}>
              <label style={{fontSize:'.68rem',fontWeight:700,color:'#9094a8',textTransform:'uppercase',letterSpacing:'.06em'}}>{f.label}</label>
              <PasswordInput value={pwForm[f.key]} onChange={e=>setPwForm({...pwForm,[f.key]:e.target.value})}
                style={{fontFamily:"'Sora',sans-serif",fontSize:'.82rem',padding:'9px 11px',border:'1.5px solid #e0e4f0',borderRadius:9,background:'#f8f9fc',color:'#1a1d2e',outline:'none',width:'100%'}} />
            </div>
          ))}
          <button className="btn btn-blue pw-btn" onClick={handleChangePassword} disabled={pwSaving} style={{alignSelf:'flex-start'}}>{pwSaving?'Changing…':'Change Password'}</button>
        </div>
      </div>
    </div>
  );
};

export default TeacherExams;